/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Create_FolderInputs */

const cs_documents_create_folder = /** @type {(inputs: Documents_Create_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová složka`)
};

const en_documents_create_folder = /** @type {(inputs: Documents_Create_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New folder`)
};

/**
* | output |
* | --- |
* | "New folder" |
*
* @param {Documents_Create_FolderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_create_folder = /** @type {((inputs?: Documents_Create_FolderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Create_FolderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_create_folder(inputs)
	return cs_documents_create_folder(inputs)
});